import { Specialty, StaticSidebarComponentOptions } from '@/lib/types';

import { SpecialtyPage } from '@/features/specialty-page';
import filterSidebarComponent from '@/features/specialty-page/utils/filter-sidebar-component.util';
import RegionsService, { Region } from '@/services/regions.service';
import SpecialtiesService from '@/services/specialties.service';

type SearchAdventureProps = {
  regions: Region[];
  specialties: Specialty[];
};

export type SearchAdventuresMap = Record<string, SearchAdventureProps>;

const get = async (
  specialtyPage: SpecialtyPage
): Promise<SearchAdventuresMap> => {
  const searchAdventureComponents = filterSidebarComponent(
    specialtyPage,
    StaticSidebarComponentOptions.SearchAdventures
  );

  if (!searchAdventureComponents || !specialtyPage.specialty?.discipline)
    return {};

  const [regions, specialties] = await Promise.all([
    RegionsService.get(),
    SpecialtiesService.getByDiscipline(specialtyPage.specialty.discipline),
  ]);

  return Object.fromEntries(
    searchAdventureComponents.map((c): [string, SearchAdventureProps] => {
      return [
        c.id,
        {
          regions,
          specialties,
        },
      ];
    })
  );
};

const SearchAdventuresService = {
  get,
};

export default SearchAdventuresService;
